<template>
  <div class="article-header-compact">
    <div class="header-row header-row-top">
      <div class="header-title-slot">
        <slot name="title"></slot>
      </div>
      <div v-if="$slots.translit" class="header-translit-slot">
        <slot name="translit"></slot>
      </div>
    </div>
    <div v-if="$slots.stats" class="header-row header-row-stats">
      <slot name="stats"></slot>
    </div>
  </div>
</template>

<style scoped>
.article-header-compact {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.header-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.header-row-top {
  gap: 10px;
  justify-content: space-between;
}

.header-title-slot {
  flex: 1;
  min-width: 0;
}

.header-translit-slot {
  flex-shrink: 0;
}

.header-row-stats {
  width: 100%;
  justify-content: flex-end;
}
</style>
